import { render } from "./MaterialSnackbar.vue?vue&type=template&id=b21ec238&scoped=true"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"

import "./MaterialSnackbar.vue?vue&type=style&index=0&id=b21ec238&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21ec238"]])

export default __exports__